/* The cache is keyed by request URL; consumers build keys with these helpers so API paths stay in the store layer. */
export const rackCellQrUrl = (rackId: string, cellId: string): string => `racks/${rackId}/cells/${cellId}/qr`;
export const cartonQrUrl = (id: string): string => `cartons/${id}/qr`;
export const palletQrUrl = (id: string): string => `pallets/${id}/qr`;
export const stationQrUrl = (id: string): string => `stations/${id}/qr`;
